import * as urls from '../config'
import axios from 'axios'

export default {
  getCategorias (unidade) {
    let service = urls.WP_URL + 'categorias-documento-por-unidade/' + unidade
    return axios.get(service)
    .then(response => {
      return response
    })
    .catch(error => {
      console.log(error)
    })
  },
  getDocumentos (categoria, unidade) {
    let service = urls.WP_URL + 'documentos-por-categoria/' + categoria + '/' + unidade
    return axios.get(service)
    .then(response => {
      return response
    })
    .catch(error => {
      console.log(error)
    })
  },
  getCategoria (id) {
    let service = urls.WP_URL + 'categoria_documento/' + id
    return axios.get(service)
    .then(response => {
      return response
    })
    .catch(error => {
      console.log(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/api/DocumentoService.js